// TikTok Pixel event helpers. These ONLY fire on the live production domain —
// never on the preview/dev environment — so test traffic doesn't pollute ad data.
const PROD_HOSTS = ["narccheckai.com", "www.narccheckai.com"];

export const PLANS = {
  pro_annual: { name: "NarcCheck AI Yearly", price: 60 },
  pro_monthly: { name: "NarcCheck AI Monthly", price: 8.99 },
  signup: { name: "NarcCheck AI Account", price: 0 },
};

export function isProdHost() {
  return typeof window !== "undefined" && PROD_HOSTS.includes(window.location.hostname);
}

// Every event carries a `contents` array with a content_id (TikTok's required format).
export function ttTrack(event, contentId, extra = {}) {
  if (!isProdHost()) return;
  const plan = PLANS[contentId] || { name: contentId, price: 0 };
  try {
    if (window.ttq && typeof window.ttq.track === "function") {
      window.ttq.track(event, {
        contents: [{ content_id: contentId, content_type: "product", content_name: plan.name, price: plan.price, quantity: 1 }],
        content_type: "product",
        value: plan.price,
        currency: "USD",
        ...extra,
      });
    }
  } catch {
    /* analytics must never break a flow */
  }
}

async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text.trim().toLowerCase()));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function ttIdentify(email) {
  if (!isProdHost() || !email || !window.ttq?.identify) return;
  try {
    const hashed = await sha256(email);
    window.ttq.identify({ email: hashed, external_id: hashed });
  } catch {
    /* ignore */
  }
}
